"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var FontService_1 = __importDefault(require("DreamCoat/BrandSetUp/BrandFonts/FontService/FontService"));
var FeatureFlag_1 = require("@CommonFrontendBackend/FeatureFlag");
var FontPairs = require("SettingsAngular/BrandSetup/Fonts/TypographySelector/RecommendedPairings/RecommendedPairings");
exports.default = (function (usingFeature, make, account, brandStore, stylePermissionStore, invoke) {
    if ((0, FeatureFlag_1.isUsingNewBrandSetUp)(usingFeature)) {
        var fontSelector = make(require("SettingsAngular/BrandSetup/Fonts/TypographySelector/FontSelector/FontSelector"));
        var fontPairs = make(FontPairs);
        var fontService = make(FontService_1.default, {
            account: account,
            fontSelector: fontSelector,
            fontPairs: fontPairs,
        });
        var brandSetupOverlay_1 = make(require("Settings/NewBrandSetup/attachBrandSetup").BrandSetupOverlay, {
            account: account,
            brandStore: brandStore,
            stylePermissionStore: stylePermissionStore,
            fontService: fontService,
        });
        return function () {
            brandSetupOverlay_1.show();
        };
    }
    else {
        var oldBrandSetup_1 = require("SettingsAngular/BrandSetup/BrandSetup");
        return function () {
            invoke(oldBrandSetup_1, null, {
                options: {
                    gotoState: "colors",
                },
            });
        };
    }
});
